import { useConfiguration } from '../context/configuration-context/use-configuration';
export const usePreloadEditorPlugins = () => {
    const { pluginConfig } = useConfiguration();
    return () => {
        if (pluginConfig?.type === 'async') {
            pluginConfig.loadEditorPluginsAsync();
        }
    };
};
//# sourceMappingURL=use-preload-editor-plugins.js.map